import { FilterTemplateResponseModel } from "./filter-template.response.model";

export class DetailsViewChartDataRequest {
  //constructor(public template: FilterTemplateResponseModel){}
  constructor(public template: FilterTemplateResponseModel, public startDate: Date, public endDate: Date){}
    //constructor(public startDate: Date, public endDate: Date){  }
}
